<div class="btn-group-vertical d-flex control-panel-right">
  <button [attr.data-btnId]="getElementId('fullScreen')" *qmAuth="'map-fullscreen'" class="btn btn-outline-info"
          (click)="toggleFullScreen()"
          placement="left" container="body"
          ngbTooltip="{{'Fullscreen' | translate }}">
    <i class="far fa-expand-arrows fa-lg"></i>
  </button>
  <button [attr.data-btnId]="getElementId('zoomIn')" *qmAuth="'map-zoom-in'" class="btn btn-outline-info"
          (click)="zoomIn()"
          placement="left" container="body"
          ngbTooltip="{{'Zoom in' | translate}}">
    <i class="far fa-plus fa-lg"></i>
  </button>
  <button [attr.data-btnId]="getElementId('zoomOut')" *qmAuth="'map-zoom-out'" class="btn btn-outline-info"
          (click)="zoomOut()"
          placement="left" container="body"
          ngbTooltip="{{'Zoom out' | translate}}">
    <i class="far fa-minus fa-lg"></i>
  </button>
</div>
